import React, { FC } from "react";
import { AnswerStatuses, IMeetingConfirmation, PLANNER_DATE_FORMAT, getDateInUserTimezone, setClass } from "../../utils";
import { format } from "date-fns";

interface ConfirmationStatusProps {
  userId: number;
  confirmationUser: IMeetingConfirmation;
  initiatorId: number;
  className?: string;
  isHideTime?: boolean;
  offset: number;
}

export const ConfirmationStatus: FC<ConfirmationStatusProps> = ({ userId, isHideTime, confirmationUser, initiatorId, className, offset }) => {
  let classes = `${className ? className : 'status-text'}`;
  let message = '';

  if (confirmationUser && confirmationUser.answerStatus === AnswerStatuses.COUNTER_OFFER) {
    const tooltip = `Предлагаю в ${format(getDateInUserTimezone(confirmationUser.offeredTime, offset), PLANNER_DATE_FORMAT)}`;
    return (
      <div 
        title={isHideTime ? null : tooltip} 
        className={setClass(`${classes} status-offer`, !isHideTime && 'help-tooltip')}
      >
        Предложено свое время
      </div>
    );
  }

  if (userId === initiatorId) {
    return (<div className={`${classes} status-accepted`}>Подтверждено участие</div>);
  }

  if (confirmationUser?.answerStatus === AnswerStatuses.ACCEPTED) {
    message = 'Подтверждено участие';
    classes = `${classes} status-accepted`;
  } else if (confirmationUser?.answerStatus === AnswerStatuses.CANCELED) {
    message = 'Отказ';
    classes = `${classes}  status-rejected`;
  } else if (confirmationUser?.answerStatus === AnswerStatuses.COUNTER_OFFER_REJECTED) {
    message = 'Предложение отклонено'
    classes = `${classes} status-offer-rejected`
  } else if (confirmationUser?.answerStatus === AnswerStatuses.COUNTER_OFFER_ACCEPTED) {
    message = 'Предложение принято'
    classes = `${classes} status-accepted`
  } else if (confirmationUser?.answerStatus === AnswerStatuses.NO_RESPONSE) {
    message = 'Ожидание ответа';
    classes = `${classes}  status-no-response`;
  }
  
  return (<div className={classes}>{message}</div>)
};
